import React from "react";
import Blog from "./Components/Blog";
import Home from "./Components/Home";
import About from "./Components/About";
import NotFound from "./Components/NotFound";
import "react-toastify/dist/ReactToastify.css";
import Contactus from "./Components/Contactus";
import { Routes, Route } from "react-router-dom";
import BlogDetails from "./Components/BlogDetails";
import ThankYouPage from "./Components/ThankYouPage";
import Privacypolicy from "./Components/Privacypolicy";
import GraphicDesign from "./Components/GraphicDesign";
import WebDevelopment from "./Components/WebDevelopment";
import DigitalMarketing from "./Components/DigitalMarketing";
import MobileDevelopment from "./Components/MobileDevelopment";
import Termsandconditions from "./Components/Termsandconditions";
import SoftwareMaintenance from "./Components/SoftwareMaintenance";
import ApplicationDevelopments from "./Components/ApplicationDevelopments";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/graphic-design" element={<GraphicDesign />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/terms-and-conditions" element={<Termsandconditions />} />
        <Route path="/software-maintenance" element={<SoftwareMaintenance />} />
        <Route path="/website-design-development" element={<WebDevelopment />} />
        <Route path="/application-development" element={<ApplicationDevelopments />} />
        <Route path="/mobile-application-development" element={<MobileDevelopment />} />
      </Routes>
    </div>
  );
}

export default App;
